"use strict";
exports.setWeek = setWeek;
var _index = require("./getWeek.js");
var _index2 = require("./toDate.js");
function setWeek(date, week, options) {
  const _date = (0, _index2.toDate)(date);
  const diff = (0, _index.getWeek)(_date, options) - week;
  _date.setDate(_date.getDate() - diff * 7);
  return _date;
}
